import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import { IUpdateCandidatePosition } from '../../../../common/models/candidate/IUpdateCandidatePosition';
import { ISelectedPosition } from '../../../../common/models/position/ISelectedPosition';
import { IAppState } from '../../../../common/models/store/IAppState';
import Icon from '../../../../components/Icon';
import ModalWindow from '../../../../components/ModalWindow';
import RegularButton from '../../../../components/RegularButton';
import ChoosePositionPage from '../../../../containers/ChoosePositionPage';
import { changeCandidatePositionRoutine } from '../../routines';
import styles from './styles.module.scss';

interface IProps {
  isShown: boolean;
  candidateId: string;
  attachCandidateId?: string;
  changePosition: IBindingCallback1<IUpdateCandidatePosition>;
  onHide: IBindingAction;
}

const ChangePositionModal: FunctionComponent<IProps> = ({
  isShown,
  candidateId,
  attachCandidateId,
  onHide,
  changePosition
}) => {
  const [position, setPosition] = useState<ISelectedPosition | null>(null);

  const onCancel = () => {
    setPosition(null);
    onHide();
  };

  const onSave = () => {
    const { id, name } = position as ISelectedPosition;
    changePosition({ id: attachCandidateId || candidateId, position: { id, name: name.trim() } });
    onCancel();
  };

  return (
    <ModalWindow contentClassName="modal-wrapper small-modal" onHide={onHide} isShown={isShown}>
      <div className={styles.changePositionModal}>
        <header className="custom-modal-header">
          <FormattedMessage id="contactProfile.candidate.changePosition" defaultMessage="Change candidate’s position" />
        </header>
        <ChoosePositionPage selectedPosition={position} setPosition={setPosition} simpleVersion />
        <footer className="modal-footer-bttns">
          <RegularButton textIntlId="cancel" defaultMessage="Cancel" onClick={onCancel} variant="tertiary" />
          <RegularButton
            textIntlId="done"
            defaultMessage="Done"
            icon={<Icon icon="check" />}
            disabled={!position?.name.trim()}
            onClick={onSave}
          />
        </footer>
      </div>
    </ModalWindow>
  );
};

const mapStateToProps = ({
  choosePosition: { positions, total },
  contactProfile: { contact: { candidateId } }
}: IAppState) => ({ positions, total, candidateId });

const mapDispatchToProps = {
  changePosition: changeCandidatePositionRoutine
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePositionModal);
